import React from 'react';
import { Form, Input } from 'antd';
import { I18n } from '@aws-amplify/core';
import type { FormInstance } from 'antd/es/form';

interface CreateFormProps {
	form: FormInstance;
	type: 'organization' | 'company';
}

export function CreateForm({ form, type }: Readonly<CreateFormProps>) {
	return (
		<Form form={form} layout="vertical">
			<Form.Item
				label={I18n.get('Name')}
				name="name"
				rules={[
					{
						message: I18n.get(`Enter a name for the ${type}`),
						required: true
					}
				]}
			>
				<Input />
			</Form.Item>
		</Form>
	);
}
